import React from 'react'

export const labelDoughnut = (props) => {
  const { cx, cy, midAngle, innerRadius, outerRadius, percent, index, value } = props
  const fixedDecimal = decimal || 0
  const RADIAN = Math.PI / 180
  const SIN = Math.sin(-RADIAN * midAngle)
  const COS = Math.cos(-RADIAN * midAngle)
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5
  const x = cx + radius * COS
  const y = cy + radius * SIN
  const textAnchor = x > cx ? 'start' : 'end'

  return (
    <g>
      <text
        x={x - (COS >= 0 ? 1 : -1) * 12}
        y={y}
        dy={-16}
        dx={0}
        textAnchor={textAnchor}
        dominantBaseline="central"
        className='charts-no-cartesian__pie-label'
      >
        {`${value.toFixed(fixedDecimal)}`}
      </text>
      <text
        x={x}
        y={y}
        textAnchor={textAnchor}
        dominantBaseline="central"
        className='charts-no-cartesian__pie-label'
      >
        {`${(percent * 100).toFixed(0)}%`}
      </text>
    </g>
  )
}

export const LabelError = ({ message = 'No data in selected time range' }) => {
  return (<div className='chart-error'>{message}</div>)
}